import { hasUrlParam, setUrlParam } from 'wsm-srp-utilities';

/**
 * Matches the Akamai origins (`pictures.dealer.com`, `pictures-np.dealer.com`) and the CloudFront
 * pictures-proxy aliases (`pictures.web.dealer.com`, `pictures-np.web-np.dealer.com`).
 */
const DEALER_IMAGE_HOST_REGEX =
	/(?:^|\/\/)(pictures|images|static)(-np)?\.([a-z0-9-]+\.)*dealer\.com(?=[/:?#]|$)/;

/**
 * Determines whether a URL points at a Dealer.com image host, and therefore
 * whether Akamai Image Manager resize parameters can be applied to it.
 * this duplicates `isDealerImage` from wsm-common-data
 */
export const isDealerImage = (url) => DEALER_IMAGE_HOST_REGEX.test(url);

/**
 * Determines if Akamai Image Manager resize parameters should be added to an input Image URL.
 * Returns a string of the input URL with image resize parameters added.
 * @param {string} url - A URL string value
 */
export const addImageParams = (url) => {
	const IMAGE_WIDTH = 520;

	const imageUrl = isDealerImage(url)
		? setUrlParam(url, 'impolicy=downsize_bkpt&imdensity=1')
		: url;

	let src = imageUrl;

	const isOptimized =
		hasUrlParam(imageUrl, 'impolicy') && !hasUrlParam(url, 'impolicy');

	if (isOptimized) {
		src = setUrlParam(imageUrl, `w=${IMAGE_WIDTH}`);
	}

	return src;
};
